import { Flex } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { AuthCallbackPath } from "../../../api-types/connector-callbacks";
import { AmazonConnect } from "../../../components";
import { ConnectorNavigationGroup } from "../../../components/connect/common/navigation-group";
import { usePlatformConnectorProperties } from "../../../hooks/connector";
import { ConnectorPageTemplate } from "../components";

import { MESSAGES } from "./message-definitions";

const CONNECTOR_SLUG = "amazonrutter";

const AmazonConnectWithNav = () => {
  const postConnectPath = AuthCallbackPath.FUNDING_APPLICATION_ADD_CONNECTION;
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(customerDomain, CONNECTOR_SLUG, postConnectPath);
  const hasConnections = !!connectorProperties.connections.length;

  return (
    <Flex direction="column" gap="8">
      <AmazonConnect postConnectPath={postConnectPath} />
      <ConnectorNavigationGroup hasConnections={hasConnections} forSlug={CONNECTOR_SLUG} />
    </Flex>
  );
};

export const AmazonPage = () => {
  const intl = useIntl();

  return (
    <ConnectorPageTemplate
      title={intl.formatMessage(MESSAGES.connectTitle, { connectorName: "Amazon" })}
      primaryContent={<AmazonConnectWithNav />}
    />
  );
};
